module.exports = __webpack_public_path__ + "img/by.5d9eaa89.png";